import React from "react";
import SfcMaster from "../../components/master/Sfc";
import PageLayout from "../../components/PageLayout";

interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const SfcPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {
  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <SfcMaster />
    </PageLayout>
  );
};

export default SfcPage;
